module.exports = __webpack_public_path__ + "static/visit-2-95e2462bcb67d9af4587896f77bfef4a.jpg";